import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { team } from '../data/team';

const Home = () => {
  return (
    <div className="pt-16">
      <Hero />

      {/* What We Do */}
      <section className="py-24 bg-cream">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-sm font-semibold tracking-widest text-teal uppercase mb-4">What We Do</p>
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6">
            Intelligence infrastructure for green finance
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-10">
            We help banks, investors, and institutions navigate the complexities of 
            sustainable energy financing — from credit risk and regulatory compliance 
            to post-investment monitoring and market intelligence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/solutions"
              className="px-8 py-3 bg-navy text-white rounded-lg hover:bg-navy/90 transition-colors font-medium"
            >
              Our Solutions
            </Link>
            <Link
              to="/products"
              className="px-8 py-3 border border-navy text-navy rounded-lg hover:bg-navy/5 transition-colors font-medium"
            >
              Our Products
            </Link>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-24 bg-cream">
        <div className="max-w-4xl mx-auto px-6">
          <p className="text-sm font-semibold tracking-widest text-teal uppercase mb-4 text-center">Leadership</p>
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-16 text-center">
            Meet the founders
          </h2>
          <div className="grid md:grid-cols-2 gap-12">
            {team.map((member) => (
              <div key={member.name} className="flex items-start gap-6">
                <img
                  src={`/images/${member.photo}`}
                  className="w-20 h-20 rounded-full object-cover border-2 border-teal/20"
                  alt={member.name}
                  loading="lazy"
                />
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-teal transition-colors"
                      aria-label={`${member.name}'s LinkedIn`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                  </div>
                  <p className="text-teal font-medium mt-1">{member.role}</p>
                  <p className="text-gray-600 mt-2 text-sm leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
